import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Seo = () => {
    return (
        <div className="teboil-seo">
            <FullWrapper>
                <div className="teboil-seoWrapper">
                    <div className="teboil-seoTitle">SEO</div>
                    <div className="teboil-seoList">
                        <div>
                            При разработке интернет-магазина нужно помнить про поисковую
                            оптимизацию. Качественное SEO органически приносит часть целевого
                            трафика из&nbsp;поисковых систем без дополнительных затрат.
                        </div>
                        <div>
                            Поисковая оптимизация React приложений&nbsp;&mdash; задача непростая.
                            Но&nbsp;опыт и&nbsp;экспертиза команды &laquo;Вебпрактик&raquo;
                            подтверждают, что проекты на&nbsp;базе React из&nbsp;различных сфер
                            попадают в&nbsp;топы поисковых выдач. Мы&nbsp;используем технологию SSR,
                            которая позволяет отдавать скомпилированный HTML&nbsp;SEO-роботам.
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Seo;
